"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonToggle = void 0;
var React = require("react");
var keyboard = require("../../_Core/Keyboard");
var ButtonToggle_styles_1 = require("./ButtonToggle.styles");
var ButtonToggle = /** @class */ (function (_super) {
    __extends(ButtonToggle, _super);
    function ButtonToggle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setAsSelected = function (value) {
            React.Children.map(_this.props.children, function (child, index) {
                if (child.props.Value === value) {
                    _this.divContainer.children[index].setAttribute("aria-pressed", "true");
                    _this.divContainer.children[index].setAttribute("tabindex", "0");
                }
                else {
                    _this.divContainer.children[index].setAttribute("aria-pressed", "false");
                    _this.divContainer.children[index].setAttribute("tabindex", "-1");
                }
            });
        };
        _this.onClick = function (e) {
            var target = e.target;
            var value = target.value;
            _this.setAsSelected(value);
            _this.props.OnClick(value);
        };
        _this.onKeyDown = function (e) {
            var target = e.target;
            if (keyboard.IsSpace(e)) {
                target.click();
            }
            else if (keyboard.IsRightArrow(e)) {
                var nextTarget = target.nextSibling;
                if (nextTarget) {
                    nextTarget.focus();
                }
            }
            else if (keyboard.IsLeftArrow(e)) {
                var prevTarget = target.previousSibling;
                if (prevTarget) {
                    prevTarget.focus();
                }
            }
        };
        _this.buildRef = function (e) {
            _this.divContainer = e;
        };
        return _this;
    }
    ButtonToggle.prototype.componentDidMount = function () {
        if (this.props.Value) {
            this.setAsSelected(this.props.Value);
        }
        else {
            // initially set the item to the first value
            var childrenAmount = React.Children.count(this.props.children);
            if (childrenAmount > 0) {
                this.setAsSelected(this.divContainer.querySelector("button").value);
            }
        }
    };
    ButtonToggle.prototype.render = function () {
        return (React.createElement(ButtonToggle_styles_1.ButtonToggleGroup, { ref: this.buildRef, onClick: this.onClick, onKeyDown: this.onKeyDown }, this.props.children));
    };
    return ButtonToggle;
}(React.Component));
exports.ButtonToggle = ButtonToggle;
